import React, { useState, useEffect } from "react";
import Grid from "../../globals/dhtmlx/Grid";
import "./Grid.scss";
import "./Toolbar.css";
import Loader from "../../globals/Loader";
import { getColorPercent } from "../../../helpers/ColorPalet";
import ls from "local-storage";
import { formatMoney } from "../../../helpers/utils";

const columnas_dinamicas = [];

//Las columnas son estaticas lo que debemos hacer es ocultar las que vienen en null, con sus ecepciones
/* function obtenerColumnasOcultas (info){
  if(info && info.length > 0){
    let first_element = info[0];
    let all_columns = Object.keys(first_element);
    let columnas_validas = ["acordado_comision", "acordado_iva","acordado_ieps"];
    let columns = [];
  
    all_columns.forEach((e,i) => {
      if(!columnas_validas.includes(e)){
        if(first_element[e] == null){
          columns.push(e);
         }
      }
    });
    return columns;
  }
  return [];
} */

function Grilla(props) {
  const [ready, setReady] = useState(props.ready);

  function color_hora(diff_fechas) {
    let color = "";
    console.log("diff_fechas", diff_fechas);
    if (!isNaN(diff_fechas)) {
      if (parseInt(diff_fechas) > 24) {
        color = " mayor_hora ";
      } else {
        color = " menor_hora ";
      }
    }
    return color;
  }
  useEffect(() => {
    setReady(props.ready);
  }, [props.ready]);
  /**
   * Ponesmos un efecto para que se renderice de nuevo el grid
   * podiramos controlarlo tambien en el componenete de dhtmlx pero en este nivl funciona
   */
  useEffect(() => {
    setReady(false);
    setTimeout(() => {
      setReady(true);
    }, 50);
  }, [props.sideBarCollapsed]);
  const dataTotales = props.dataTotales;
  const fechaActualizacion = props.fechaActualizacion;
  const columnas = [
    {
      id: "index",
      header: [{}, {}, {}],
      hidden: true,
    },
    {
      width: 30,
      maxWidth: 30,
      id: "cb",
      header: [
        {
          headerSort: false,
        },
        {
          headerSort: false,
          text: '<span class="fa fa-question-circle tooltip-grid"><span class="tooltiptext">Mantener CTRL para multiselección</span></span>',
        },
        {
          headerSort: false,
          text: '<input title="Seleccionar todo, para selección multiple mantener ctrl" class="dhx_checkbox__visual-input" type="checkbox" id="cb_select_all" name="select_all" >',
        },
      ],
      footer: [
        {
          text:
            "Total de elementos: " +
            dataTotales.registros +
            ", Ultima Actualización: " +
            fechaActualizacion,
          colspan: 15,
        },
      ],
      active: false,
      htmlEnable: true,
      risezable: false,
      type: "boolean",
      editable: true,
      tooltip: false,
    },
    {
      id: "id_compra",
      header: [
        { headerSort: false },
        { align: "left", text: "id <br>Compra" },
        { sorteable: false },
      ],
      width: 80,
      align: "center",
      hidden: props.concepto !== "id_compra" ? true : false,
    },
    {
      id: "no_factura",
      header: [
        { headerSort: false },
        { align: "left", text: "No <br>Factura" },
        { sorteable: false },
      ],
      align: "center",
      adjust: "data",
      hidden: props.concepto !== "id_compra" ? true : false,
    },
    {
      id: "fecha_compra_efectiva",
      header: [
        { headerSort: false },
        { align: "left", text: "Fecha <br>Compra Efectiva" },
        { sorteable: false },
      ],

      width: 130,
      hidden: props.concepto !== "id_compra" ? true : false,
    },
    {
      id: "titulos",
      header: [
        { headerSort: false },
        { align: "left", text: "Titulos" },
        { sorteable: false },
      ],
      type: "number",
      format: "#,#",
      template: (i) => `${i ? i : ""}`,
      width: 60,
      hidden: props.concepto !== "id_compra" ? true : false,
    },
    {
      id: "compra_lote",
      header: [
        { headerSort: false },
        { align: "left", text: "Compra<br> Lote" },
        { headerSort: false },
      ],
      align: "right",
      type: "number",
      format: "#",
      template: (i) => `${i ? i : ""}`,
      width: 120,
      hidden: props.concepto !== "id_compra" ? true : false,
    },
    {
      id: "upc",
      header: [
        { headerSort: false },
        { align: "left", text: "UPC" },
        { headerSort: false },
      ],
      align: "center",
      maxWidth: 150,
      width: 100,
      hidden: props.concepto !== "upc" ? true : false,
    },
    {
      width: 320,
      id: "nombre",
      header: [
        { headerSort: false },
        { align: "left", text: "Producto" },
        { headerSort: false },
      ],
      hidden: props.concepto !== "upc" ? true : false,
    },
    {
      id: "plataforma",
      header: [
        { headerSort: false },
        { align: "left", text: "Plataforma" },
        { headerSort: false },
      ],

      align: "center",
      width: 80,
      hidden: props.concepto !== "upc" ? true : false,
    },
    {
      autoWidth: props.concepto === "categoria" ? true : false,
      width: props.concepto === "categoria" ? 0 : 200,
      minWidth: 10,
      id: "categoria",
      header: [
        { headerSort: false },
        { align: "left", text: "Categoria" },
        { headerSort: false },
      ],
      hidden:
        props.concepto === "upc" || props.concepto === "categoria"
          ? false
          : true,
    },
    {
      id: "id_publisher",
      header: [{}, {}, {}],
      hidden: true,
    },
    {
      autoWidth: props.concepto === "publisher" ? true : false,
      width: props.concepto === "publisher" ? 0 : 150,
      id: "publisher",
      header: [{}, { align: "left", text: "Publisher" }, {}],
      hidden:
        props.concepto === "upc" || props.concepto === "publisher"
          ? false
          : true,
    },
    {
      id: "unidades_iniciales", //el background esta en el css
      header: [
        {
          headerSort: false,
          align: "center",
          text: `<span class="tooltip-grid-header"> A
                  <span class="tooltiptext">Compras Acumuladas</span>
                </span>`,
        },
        {
          align: "left",
          text: "Compras <br>Acumuladas",
        },
        { headerSort: false, text: dataTotales.unidades_iniciales },
      ],
      tooltip: false,
      type: "number",
      format: "#,#",
      width: 100,
      template: (i) => `${i ? i : ""}`,
    },
    {
      id: "unidades_periodo",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> B
                  <span class="tooltiptext">Venta Periodo (Unidades)</span>
                </span>`,
        },
        { align: "left", text: "Venta Periodo <br> (Unidades)" },
        { headerSort: false, text: dataTotales.unidades_periodo },
      ],
      tooltip: false,
      type: "number",
      format: "#,#",
      adjust: "data",
      minWidth: 100,
      htmlEnable: true,
      template: function (i) {
        return `${i ? i : ""}`;
      },
    },
    {
      id: "unidades_restantes",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> C
                  <span class="tooltiptext">Inventario Actual en Tiendas y Almacen</span>
                </span>`,
        },
        { align: "left", text: "Inventario en <br> (Tienda + Almacen)" },
        { headerSort: false, text: dataTotales.unidades_restantes },
      ],
      tooltip: false,
      type: "number",
      format: "#,#",
      width: 100,
      template: (i) => `${i ? i : ""}`,
    },
    {
      id: "periodo_venta", //el background esta en el css
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> D
                  <span class="tooltiptext">Ventas del Periodo $</span>
                </span>`,
        },
        { align: "left", text: "Ventas del <br> Periodo $" },
        { headerSort: false, text: "$ " + dataTotales.periodo_venta },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 100,
    },
    {
      id: "porcentaje",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> E
                  <span class="tooltiptext">[ ( A - C ) * 100 ] / A</span>
                </span>`,
        },
        { align: "left", text: "% Completado" },
        { sorteable: false },
      ],
      mark: function (cell) {
        return getColorPercent(cell);
      },
      tooltip: false,
      type: "number",
      format: "#.00",
      template: (i) => `${i ? i + "%" : ""}`,
      width: 100,
    },
    {
      id: "periodo_costo",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> F
                  <span class="tooltiptext">{ D / [ ( N / 100 ) + 1 ] } * { [ 100 - M ] / 100 }</span>
                </span>`,
        },
        { align: "left", text: "Costo de <br> Venta $" },
        { headerSort: false, text: "$ " + dataTotales.periodo_costo },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 100,
    },
    {
      id: "periodo_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> G
                  <span class="tooltiptext">F * ( N / 100 )</span>
                </span>`,
        },
        { align: "left", text: "IVA del costo <br> de venta $" },
        { headerSort: false, text: "$ " + dataTotales.periodo_iva },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 100,
    },
    {
      width: 100,
      id: "periodo_ieps",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> H
                  <span class="tooltiptext">F * ( O / 100 )</span>
                </span>`,
        },
        { align: "left", text: "IEPS del costo <br> de venta $" },
        { headerSort: false, text: "$ " + dataTotales.periodo_ieps },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
    },
    {
      minWidth: 100,
      id: "periodo_pago_proveedor",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> I
                  <span class="tooltiptext">F + G + H</span>
                </span>`,
        },
        { align: "left", text: "Pagado" },
        { headerSort: false, text: "$ " + dataTotales.periodo_pago_proveedor },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      adjust: "data",
    },
    {
      id: "periodo_costo_promedio_unidad_vendida",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> J
                  <span class="tooltiptext">Costo % Venta del Periodo</span>
                </span>`,
        },
        { align: "left", text: "Costo % <br> Venta del Periodo" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: props.concepto === "upc" ? 80 : 100,
    },
    {
      id: "periodo_costo_promedio_unidad_factura_inicial",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> K
                  <span class="tooltiptext">Costo % Factura del Periodo</span>
                </span>`,
        },
        { align: "left", text: "Costo % <br> Factura del Periodo" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: props.concepto === "upc" ? 80 : 100,
    },
    {
      id: "precio_actual_tiendas",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> L
                  <span class="tooltiptext">Precio Actual en Tiendas Físicas</span>
                </span>`,
        },
        { align: "left", text: "Precio Actual <br>Tiendas Físicas" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: props.concepto === "upc" ? 80 : 100,
    },
    {
      id: "margen_gp",
      css: "margen-row",
      header: [
        {
          align: "center",
          headerSort: false,
          text: ``,
        },
        { align: "left", text: "Margen <br> Sin IVA" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      mark: () => "margen-row",
      template: (_i, row) => {
        return formatMoney(
          row.periodo_venta > 0 ? row.periodo_venta - row.periodo_costo : null
        );
      },
      width: 80,
    },
    {
      id: "margen_gp_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: ``,
        },
        { align: "left", text: "Margen <br> Con IVA" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      mark: () => "margen-row",

      template: (_i, row) => {
        return formatMoney(
          row.periodo_venta > 0
            ? row.periodo_venta - row.periodo_costo - row.periodo_iva
            : null
        );
      },
      width: 80,
    },
    {
      id: "acordado_comision",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> M
                  <span class="tooltiptext">Comisión para GP</span>
                </span>`,
        },
        { align: "left", text: "Comisión <br> para GP" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      template: (i) => `${i ? i + "%" : ""}`,
      width: props.concepto === "upc" ? 60 : 80,
    },
    {
      id: "acordado_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> N
                  <span class="tooltiptext">Comisión para GP</span>
                </span>`,
        },
        { align: "left", text: "IVA del costo<br> de la venta %" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#",
      template: (i) => `${i ? i + "%" : ""}`,
      width:
        props.concepto === "upc" || props.concepto === "id_compra" ? 75 : 90,
    },
    {
      id: "acordado_ieps",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> O
                  <span class="tooltiptext" style="left:-140px!important">IEPS del costo de la venta %</span>
                </span>`,
        },
        { align: "left", text: "IEPS del costo<br> de la venta %" },
        { sorteable: false },
      ],
      risezable: false,
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? i + "%" : ""}`,
      width:
        props.concepto === "upc" || props.concepto === "id_compra" ? 70 : 90,
    },
  ];
  const columnasDetalle = [
    {
      id: "index",
      header: [{}, {}, {}],
      hidden: true,
    },
    {
      id: "id_venta",
      header: [
        {},
        {
          align: "left",
          text: "id Venta",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      footer: [
        {
          text:
            "Total de registros: " +
            props.data.length +
            ", Ultima Actualización: " +
            fechaActualizacion,
          colspan: 3,
        },
      ],
      align: "center",
      adjust: "data",
    },
    {
      id: "fecha",
      header: [
        {},
        {
          align: "left",
          text: "Fecha Movimiento",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      adjust: "data",
      align: "center",
      mark: (c, a, row) => {
        return color_hora(row.diff_fechas);
      },
    },
    {
      id: "fecha_ingreso",
      header: [
        {},
        {
          align: "left",
          text: "Fecha Ingreso<br/>Marketplace",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      adjust: "data",
      align: "center",
      mark: (val, e, row) => {
        return color_hora(row.diff_fechas);
      },
    },
    {
      id: "fecha_ingreso_epod",
      header: [
        {},
        {
          align: "left",
          text: "Fecha Ingreso<br/>Epod",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      width: 120,
      align: "center",
    },
    {
      id: "upc",
      header: [
        {},
        {
          align: "left",
          text: "UPC",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { headerSort: false },
      ],
      align: "center",
      adjust: "data",
    },
    {
      id: "nombre",
      header: [
        {},
        {
          align: "left",
          text: "Producto",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      width: 320,
    },
    {
      id: "plataforma",
      header: [
        {},
        {
          align: "left",
          text: "Plataforma",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      align: "center",
      width: 80,
    },
    {
      width: 150,
      id: "categoria",
      header: [
        {},
        {
          align: "left",
          text: "Categoria",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
    },
    {
      id: "id_publisher",
      header: [{}, {}, {}],
      hidden: true,
    },
    {
      width: 120,
      id: "publisher",
      header: [
        {},
        {
          align: "left",
          text: "Publisher",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
    },
    {
      width: 60,
      id: "id_caja",
      header: [
        {},
        {
          align: "left",
          text: "Id <br> Caja",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      type: "number",
      hidden: ls.get("admin") ? false : true,
    },
    {
      width: 60,
      id: "id_compra",
      header: [
        {},
        {
          align: "left",
          text: "Id <br> Compra",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      type: "number",
    },
    {
      id: "lote",
      header: [
        {},
        {
          align: "left",
          text: "Lote",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      type: "number",
      minWidth: 60,
      adjust: "data",
    },
    {
      id: "lote_actualizacion",
      header: [
        {},
        {
          align: "left",
          text: "Lote Actualización",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
      type: "number",
      minWidth: 100,
      adjust: "data",
    },
    {
      adjust: "data",
      id: "tipo_calculo",
      header: [
        {},
        {
          align: "left",
          text: "Tipo Calculo",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
      ],
    },
    {
      width: 80,
      id: "unidades",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> A
                  <span class="tooltiptext">Vetas Periodo (Unidades)</span>
                </span>`,
        },
        {
          align: "left",
          text: "Vetas Periodo <br>(Unidades)",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      tooltip: false,
      type: "number",
      format: "#,#",
      template: (i) => `${i ? i : ""}`,
    },
    {
      id: "periodo_venta", //el background esta en el css
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> B
                  <span class="tooltiptext">Ventas del Periodo $</span>
                </span>`,
        },
        {
          align: "left",
          text: "Ventas del <br> Periodo $",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      tooltip: false,
      adjust: "data",
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
    },
    {
      id: "periodo_costo",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> C
                  <span class="tooltiptext">{ B / [ ( J / 100 ) + 1 ] } * { [ 100 - I ] / 100 }</span>
                </span>`,
        },
        {
          align: "left",
          text: "Costo de <br> Venta $",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 80,
    },
    {
      id: "periodo_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> D
                  <span class="tooltiptext"> C * ( J / 100 )</span>
                </span>`,
        },
        {
          align: "left",
          text: "IVA del costo <br> de venta $",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 80,
    },
    {
      width: 50,
      id: "periodo_ieps",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> E
                  <span class="tooltiptext"> C * ( K / 100 )</span>
                </span>`,
        },
        {
          align: "left",
          text: "IEPS del costo <br> de venta $",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
    },
    {
      minWidth: 80,
      id: "periodo_pago_proveedor",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> F
                  <span class="tooltiptext"> C + D + E</span>
                </span>`,
        },
        {
          align: "left",
          text: "Pagado",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { content: "sum" },
      ],
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      adjust: "data",
    },
    {
      id: "periodo_costo_promedio_unidad_vendida",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> G
                  <span class="tooltiptext">Costo % Venta del Periodo</span>
                </span>`,
        },
        {
          align: "left",
          text: "Costo % <br> Venta del Periodo",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 80,
    },
    {
      id: "periodo_costo_promedio_unidad_factura_inicial",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> H
                  <span class="tooltiptext">Costo % Factura del Periodo</span>
                </span>`,
        },
        {
          align: "left",
          text: "Costo % <br> Factura del Periodo",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? "$ " + i : ""}`,
      width: 80,
    },
    {
      id: "margen_gp",
      css: "margen-row",
      header: [
        {
          align: "center",
          headerSort: false,
          text: ``,
        },
        { align: "left", text: "Margen <br> Sin IVA" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      mark: () => "margen-row",
      template: (_i, row) => {
        return formatMoney(
          row.periodo_venta > 0 ? row.periodo_venta - row.periodo_costo : null
        );
      },
      width: 80,
    },
    {
      id: "margen_gp_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: ``,
        },
        { align: "left", text: "Margen <br> Con IVA" },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      mark: () => "margen-row",

      template: (_i, row) => {
        return formatMoney(
          row.periodo_venta > 0
            ? row.periodo_venta - row.periodo_costo - row.periodo_iva
            : null
        );
      },
      width: 80,
    },

    {
      id: "acordado_comision",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> I
                  <span class="tooltiptext">Comisión para GP</span>
                </span>`,
        },
        {
          align: "left",
          text: "Comisión <br> para GP",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number", //el tipo percent no funciona muestra algo como 4200% cuando el valor es 42.00
      format: "#,#.00",
      template: (i) => `${i ? i + "%" : ""}`,
      width: 60,
    },
    {
      id: "acordado_iva",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> J
                  <span class="tooltiptext" style="left:-80px!important">IVA del costo de la venta %</span>
                </span>`,
        },
        {
          align: "left",
          text: "IVA del costo<br> de la venta %",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? i + "%" : "0"}`,
      width: 60,
    },
    {
      id: "acordado_ieps",
      header: [
        {
          align: "center",
          headerSort: false,
          text: `<span class="tooltip-grid-header"> K
                  <span class="tooltiptext" style="left:-150px!important">IEPS del costo de la venta %</span>
                </span>`,
        },
        {
          align: "left",
          text: "IEPS del costo<br> de la venta %",
          css: props.isDetalleHistorico ? "header-historico" : "",
        },
        { sorteable: false },
      ],
      tooltip: false,
      type: "number",
      format: "#,#.00",
      template: (i) => `${i ? i + "%" : "0"}`,
      width: 60,
    },
  ];
  if (ready) {
    let columnsActuales = columnas;
    let columnasDinamicasDefault = columnas_dinamicas;
    let toogleSelected = props.toogleSelected;
    let verDetalle = props.verDetalle;
    let mostrarTodo = props.mostrarTodo;
    if (props.isDetalle) {
      columnsActuales = columnasDetalle;
      toogleSelected = () => {};
      verDetalle = () => {};
      mostrarTodo = true;
    }
    return (
      <Grid
        ready={ready}
        columns={columnsActuales}
        data={props.data}
        filtro={props.filtro}
        columnasOcultas={[]}
        columnas_dinamicas={columnasDinamicasDefault}
        toogleSelected={toogleSelected}
        css={" grid_ventas"}
        exportGrid={props.exportGrid}
        toogleExportGrid={props.toogleExportGrid}
        verDetalle={verDetalle}
        isDetalle={props.isDetalle}
        isDetalleHistorico={props.isDetalleHistorico}
        mostrarTodo={mostrarTodo}
      />
    );
  }
  return <Loader />;
}
export default Grilla;
